export const validateAndFormatTime = (value: string) => {
  if (!value) return value;

  // Keep only numbers and colons
  const cleaned = value.replace(/[^\d:]/g, "");

  // Handle single digit
  if (cleaned.length === 1) return cleaned;

  // Add colons after 2 and 5 digits
  let formatted = cleaned;
  if (cleaned.length > 2 && !cleaned.includes(":")) {
    formatted = cleaned.slice(0, 2) + ":" + cleaned.slice(2);
  }
  if (formatted.length > 5 && formatted.split(":").length === 2) {
    const [hours, rest] = formatted.split(":");
    formatted = hours + ":" + rest.slice(0, 2) + ":" + rest.slice(2);
  }

  // Split time components
  const parts = formatted.split(":");
  const hours = parts[0] ? parseInt(parts[0]) : 0;
  const minutes = parts[1] ? parseInt(parts[1]) : 0;
  const seconds = parts[2] ? parseInt(parts[2]) : 0;

  // Validate and adjust hours
  if (hours > 23) {
    formatted = "23" + formatted.slice(2);
  }

  // Validate and adjust minutes
  if (parts[1] && minutes > 59) {
    formatted = parts[0] + ":59" + (parts[2] ? ":" + parts[2] : "");
  }

  // Validate and adjust seconds
  if (parts[2] && seconds > 59) {
    formatted = parts[0] + ":" + parts[1] + ":59";
  }

  return formatted;
};
